export default "__VITE_ASSET__t46711sY__"